import { customElement } from 'lit/decorators.js';
import WwpStationDetail from '@kisters/wiski-web/components/wwp-station-detail/wwp-station-detail.ts';
import {
getRouteOptionsAndParams
} from '@kisters/wiski-web/components';

//@ts-ignore
@customElement('wwp-station-detail-hdoe')
export default class WwpStationDetailHdoe extends WwpStationDetail {

    //@ts-ignore
     onAfterEnter(location, options, router) {
         const params = getRouteOptionsAndParams(location, [
            'layerName',
            'stationId',
            'stationLabel',
        ]);
        Object.assign(this, params.options);
    
        this.remarkAttr = this.config.remarkAttr;
        const mainRouteLength = location.route.path.split('/').length;
        this._search = location.search;
        this.currentRoute = location.route;
    
        this.currentRoute.children = this.currentRoute.children.filter(
          item => !(item.isDynamic || item.path?.includes('dyn_')),
        );
        this.currentRoute.__children = this.currentRoute.__children.filter(
          item => !(item.isDynamic || item.path?.includes('dyn_')),
        );
    
        this._mainRoute = location.pathname
          .split('/')
          .slice(0, mainRouteLength)
          .join('/');
        this._menuListRaw =
          location.route.children?.map(item => ({
            ...item,
            detailSelection: item.detailSelection || item.path.slice(1),
          })) ?? [];
        if (this._mainRoute !== location.pathname) {
          this._selectedMenuItem = `/${location.pathname
            .split('/')
            .slice(mainRouteLength)
            .join('/')}`;
        } else {
          this._selectedMenuItem =
            location.pathname === router.context.resolver.location.redirectFrom ||
            !router.context.resolver.location.redirectFrom
              ? null
              : `/${router.context.resolver.location.redirectFrom
                  .split('/')
                  .slice(-1)}`;
        }
    
        this.router = router;
    
        // Switch back to main menu on navigation (mobile) 
        this.router.navigationChange = (newRoute, oldRoute) => {
          if (newRoute.length < oldRoute.length) {
            this.__selectedItem = this._selectedMenuItem;
            this._selectedMenuItem = '';
            this.requestUpdate();
          }
        };
        //@ts-expect-error
        this.stationId = params.stationId;
        this.stationLabel = params.stationLabel;
        this.fetchData(params.layerName);
      }

}